import { mapState } from "vuex";

import {
  SEND_RECEIPT_DOCUMENTS,
  SEND_RECEIPT_CANCELLATION_DOCUMENTS,
  EXPORT_PDF_DOCUMENTS,
  EXPORT_XML_DOCUMENTS,
} from "@/store/documents/actions";

export default {
  data() {
    return {
      isOpenReceiptConfirm: false,
    };
  },
  methods: {
    $documentFormat(id, series) {
      if (!id) {
        return null;
      }
      
      if (!series) {
        return `${id}`;
      }
      
      return `${id}/${series}`;
    },
    $documentGenerate(id, series) {
      id = id ? id + 1 : 1;
      series = series || this.$moment().format('YYYY');

      return this.$documentFormat(id, series);
    },
    exportPDF(id) {
      this.$store.dispatch(EXPORT_PDF_DOCUMENTS, id);
    },
    exportXML(id) {
      this.$store.dispatch(EXPORT_XML_DOCUMENTS, id);
    },
    cancelReceipt(id) {
      this.receiptCancellationLoading = true;
      this.$store.dispatch(SEND_RECEIPT_CANCELLATION_DOCUMENTS, {
        id
      }).then(() => {
        this.receiptCancellationLoading = false;
        this.isOpenReceiptCancel = false;
      })
    },
  },
  computed: {
    ...mapState({
      sendReceiptRequest: state => state.documents.sendReceiptRequest,
      cancelReceiptRequest: state => state.documents.sendReceiptCancellationRequest,
    })
  },
}
